import Cookies from 'js-cookie';

const ClearCookies = async () => {
	Cookies.remove('name');
	Cookies.remove('name1');
	Cookies.remove('email');
	Cookies.remove('role');
	Cookies.remove('role_name');
	Cookies.remove('role_name1');
	Cookies.remove('userToken');
	Cookies.remove('userToken1');
	Cookies.remove('id');
	Cookies.remove('id1');
	Cookies.remove('Data');
	Cookies.remove('Data1');
	Cookies.remove('last_login');
	Cookies.remove('last_login1');
	Cookies.remove('roleId');
	Cookies.remove('role_id');
	Cookies.remove('role_id1');
	Cookies.remove('userID');
	Cookies.remove('companyID');
	Cookies.remove('rolesList');
};
export default ClearCookies;
